var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.39648,
    y: 4.35107,
    width: 10.1037,
    height: 10.1491,
    rx: 1.5,
    stroke: "#2E77D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0477 2.60877V2.03314C11.0275 1.75037 10.8425 1.14848 10.2632 1.00306H2.35779C1.90519 0.972765 1 1.15454 1 2.12403V10.0314C1 10.3343 1.19311 10.9706 1.96554 11.0918H2.75004",
    stroke: "#2E77D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.b477802a5d076b778e575c4de909a5ea.svg";
export { ForwardRef as ReactComponent };